import Layout from '@/layout'

const route = {
  path: '/applimanagement',
  component: Layout,
  redirect: '/applimanagement/index',
  alwaysShow: true, // will always show the root menu
  name: 'applimanagement',
  meta: {
    title: ' 应用管理',
    icon: 'PM',
    roles: [
      'program_manage'
    ]
  },
  children: [
    {
      path: '/wechatIndex/index',
      name: 'wechatIndex',
      component: () => {
        return import('@/views/messageTemplate/index.vue')
      },
      meta: {
        title: '小程序管理',
        roles: [
          'program_manage.mini_program'
        ]
      },
      children: [
        {
          path: '/applicationwechat/index',
          component: () => import('@/views/applicationwechat/index.vue'),
          name: 'Applicationwechat',
          meta: {
            title: '小程序列表',
            roles: [
              'program_manage.mini_program.index'
            ]
          }
        },
        {
          path: '/applicationlink/index',
          component: () => import('@/views/applicationlink/index.vue'),
          name: 'Applicationlink',
          meta: {
            title: '小程序链接列表',
            roles: [
              'program_manage.urlLink.index'
            ]
          }
        }
      ]
    },
    {
      path: '/applicationlink/adPage/index',
      component: () => import('@/views/adPage/index.vue'),
      name: 'adPage',
      meta: {
        title: '课程投放h5',
        icon: 'component',
        roles: [
          'promotion_link.static_html_link'
        ]
      }
    },
    {
      path: '/applicationlink/adEnvConfig/index',
      component: () => import('@/views/adEnvConfig/index.vue'),
      name: 'adEnvConfig',
      meta: {
        title: '变量配置',
        icon: 'component',
        roles: [
          'environment.variable_configs'
        ]
      }
    }
  ]
}

export default route
